const translations = {
    na: 'N/A'
};

export default translations;
